import React from "react";
import { useNavigate } from "react-router-dom";
import { AppShell, ButtonBase, CardPanel, PanelTitleRow } from "../components";

const PrivacyNoticePage = () => {
  const navigate = useNavigate();

  return (
    <AppShell logoPosition="bottom">
      <CardPanel className="ui-card-panel--wide">
        <div className="ui-admin-card">
          <PanelTitleRow title="Privacy Notice" />

          <div
            style={{
              display: "grid",
              gap: "18px",
              lineHeight: "1.7",
            }}
          >
            <p>
              This Privacy Notice explains how RCCG Praise Embassy (Eton-Wick)
              Sunday School Department collects and uses your information for
              attendance and class administration purposes.
            </p>

            <div>
              <h3>Information We Collect</h3>
              <p>
                We may collect your name, email address, phone number,
                attendance records, and questions submitted through the Sunday
                School platform.
              </p>
            </div>

            <div>
              <h3>How We Use Your Information</h3>
              <p>
                Your information is used only for Sunday School attendance,
                communication, class administration, and responding to submitted
                questions.
              </p>
            </div>

            <div>
              <h3>Who Can Access Your Information</h3>
              <p>
                Your information is accessible only to authorised Sunday School
                teachers and church administrators.
              </p>
            </div>

            <div>
              <h3>Data Retention</h3>
              <p>
                Records are typically retained for up to 12 months for Sunday
                School administration and attendance purposes, after which they
                may be securely removed when no longer required.
              </p>
            </div>

            <div>
              <h3>Sharing of Information</h3>
              <p>
                Your information is not sold or shared with third parties except
                where required by law.
              </p>
            </div>

            <div>
              <h3>Contact</h3>
              <p>
                For questions regarding your information or this Privacy Notice,
                please contact:
              </p>

              <p>
                <strong>info@rccgchurchatslough.com</strong>
              </p>
            </div>

            <div style={{ marginTop: "10px" }}>
              <ButtonBase variant="navy" onClick={() => navigate(-1)}>
                Go Back
              </ButtonBase>
            </div>
          </div>
        </div>
      </CardPanel>
    </AppShell>
  );
};

export default PrivacyNoticePage;
